export default [
    {
      path: '/users-feedback',
      name: 'users-feedback',
      component: () => import('@/views/users-feedback/UsersFeedback.vue'),
    }
  ]
  